import angular from 'angular';
import assignmentConfirmationComponent from './assignmentConfirmation.component';

let assignmentConfirmationModule = angular.module('assignmentConfirmation', []).directive('assignmentConfirmation', assignmentConfirmationComponent);

export default assignmentConfirmationModule;



// WEBPACK FOOTER //
// ./app/components/assignmentConfirmation/assignmentConfirmation.js